import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import { useLang } from "@/lib/i18n";

interface Ctx { ids: string[]; toggle: (id: string) => void; remove: (id: string) => void; clear: () => void; has: (id: string) => boolean; full: boolean }
const CompareCtx = createContext<Ctx>(null!);
export const COMPARE_MAX = 3;
const KEY = "lvc_compare";

export function CompareProvider({ children }: { children: React.ReactNode }) {
  const { t } = useLang();
  const [ids, setIds] = useState<string[]>(() => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } });
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(ids)); }, [ids]);
  const toggle = (id: string) => setIds((cur) => {
    if (cur.includes(id)) return cur.filter((x) => x !== id);
    if (cur.length >= COMPARE_MAX) { toast.error(t("cmp.max", { n: COMPARE_MAX })); return cur; }
    return [...cur, id];
  });
  const value: Ctx = { ids, toggle, remove: (id) => setIds((c) => c.filter((x) => x !== id)), clear: () => setIds([]), has: (id) => ids.includes(id), full: ids.length >= COMPARE_MAX };
  return <CompareCtx.Provider value={value}>{children}</CompareCtx.Provider>;
}

export const useCompare = () => useContext(CompareCtx);
